import { render, staticRenderFns } from "./OrdersLogsPopup.vue?vue&type=template&id=487ac951&scoped=true&"
import script from "./OrdersLogsPopup.vue?vue&type=script&lang=js&"
export * from "./OrdersLogsPopup.vue?vue&type=script&lang=js&"
import style0 from "./OrdersLogsPopup.vue?vue&type=style&index=0&id=487ac951&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487ac951",
  null
  
)

export default component.exports